module.exports = __webpack_public_path__ + "img/couples-057.4396f3d6.jpg";